import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import { DefaultFormId } from "../config/resolveView";
import { designerReturnState } from "../builder/designerReturn";
import { PageBarEditViewLinkProps } from "./PageBarEditViewLink.types";

const ButtonClass = "btn border rounded-2 bg-white text-dark fw-medium";

/**
 * Opens the view the record is currently on in the designer, in the same tab with a way
 * back. A link, not a button, so the browser's own new-tab handling still works.
 */
export function PageBarEditViewLink({
  pagePath,
  formId,
}: PageBarEditViewLinkProps) {
  const location = useLocation();

  // The shipped default has no row to save to, so there is nothing to edit on it.
  // Offered as a disabled control rather than hidden, so the reason can be read.
  if (formId === DefaultFormId) {
    return (
      <button
        type="button"
        className={ButtonClass}
        title="The default view cannot be edited - duplicate it instead"
        disabled
      >
        Edit view
      </button>
    );
  }

  return (
    <Link
      className={classNames(ButtonClass, "hover-bg-light")}
      to={`/manage-views${pagePath}/${formId}`}
      state={designerReturnState(location)}
    >
      Edit view
    </Link>
  );
}

export default PageBarEditViewLink;
